module.exports = __webpack_public_path__ + "img/logo.5e1d8f37.png";